/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thisishowyoureventwillappeartousers8Inputs */

const en_thisishowyoureventwillappeartousers8 = /** @type {(inputs: Thisishowyoureventwillappeartousers8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is how your event will appear to users`)
};

const de_thisishowyoureventwillappeartousers8 = /** @type {(inputs: Thisishowyoureventwillappeartousers8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So sehen andere dein Event.`)
};

/**
* | output |
* | --- |
* | "This is how your event will appear to users" |
*
* @param {Thisishowyoureventwillappeartousers8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const thisishowyoureventwillappeartousers8 = /** @type {((inputs?: Thisishowyoureventwillappeartousers8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thisishowyoureventwillappeartousers8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thisishowyoureventwillappeartousers8(inputs)
	return de_thisishowyoureventwillappeartousers8(inputs)
});
export { thisishowyoureventwillappeartousers8 as "thisIsHowYourEventWillAppearToUsers" }